module.exports = __webpack_public_path__ + "img/character-pin-map.ba72ca85.png";